import React from "react";

import { css } from "@emotion/css";
import { useNavigate } from "@tanstack/react-router";
import { ErrorBoundary } from "react-error-boundary";

import { Icons } from "@/assets/icons";
import { useStyles } from "@/hooks/useStyles";
import { Theme } from "@/theme/CreateTheme.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { AccountMenu } from "@/uiKit/molecules/AccountMenu";
import { Logout } from "@/uiKit/molecules/Logout";
import { Sentry } from "@/utils/sentryUtils";

export const AuthenticatedPageHeader: React.FC = () => {
  const styles = useStyles(makeStyles);
  const navigate = useNavigate();
  const [counter, setCounter] = React.useState(0);
  const sentryDebug = () => {
    if (counter < 4) {
      setCounter(counter + 1);
    } else {
      console.info("Debugging Sentry");
      Sentry.captureException(new Error("Debugging Sentry"));
      setCounter(0);
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.logoContent}>
        <Icons.logoBlueFull
          className={styles.icon}
          onClick={() => {
            sentryDebug();
            return navigate({ to: "/" });
          }}
        />
        {import.meta.env.MODE !== "production" && (
          <Typography className={styles.envText} variant="caption">
            {import.meta.env.MODE}
          </Typography>
        )}
      </div>
      <div className={styles.divider} />
      <ErrorBoundary fallback={<Logout className={styles.menu} />}>
        <AccountMenu className={styles.menu} />
      </ErrorBoundary>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    width: 100%;
  `,
  logoContent: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: ${theme.spacing(8, 16)};
  `,
  icon: css`
    height: ${theme.typography.h4.fontSize};
    width: auto;
    cursor: pointer;
  `,
  envText: css`
    color: ${theme.palette.primary.main};
    opacity: 0.5;
  `,
  menu: css`
    margin: ${theme.spacing(8, 16)};
  `,
  divider: css`
    flex: 1 1;
  `,
});
